<template>
  <div id="elpotosino" class="my-5">
    <div v-if="galleryParador" class="container w-75 d-flex justify-content-center align-items-start">
      <img class="rounded img-fluid" :src="galleryParador.images_url" alt="" >
    </div>
    <main class="main-content border-radius-lg justify-content-center mt-5 mb-5" style="position: static;">
      <div class="container-fluid justify-content-center" style="position: static;">
        <div class="row justify-content-center" style="position: static;">
          <div class="col-sm-4 col-12 d-flex justify-content-center align-items-center" v-if="galleryPaSlider">
            <div class="card-carousel w-100 h-100 p-0" v-if="galleryPaSlider.images_url.length != 0">
              <div id="carouselExampleCaptions3" class="carousel slide w-100 h-100" data-bs-ride="carousel">
                <div class="carousel-inner border-radius-lg w-100 h-100">
                  <div v-for="(image, index) in galleryPaSlider.images_url" :key="image"
                    :class="index === 0 ? 'carousel-item w-100 h-100 active' : 'carousel-item w-100 h-100'">
                    <img :src="image" alt="" class="img-fluid border-radius-lg">
                  </div>
                </div>
                <button class="carousel-control-prev w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions3"
                  data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions3"
                  data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3">
                <h3 style="color: #d4041b !important;">Parador El Potosino</h3>
              </div>
              <div class="card-body p-3">
                <div class="justify-content-center" style="text-align: justify">
                  <small>{{ hostel }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "paradorinf",
  data() {
    return {
      manageables: undefined,
      galleryParador: undefined,
      galleryPaSlider: undefined,
    };
  },
  props: {
    hostel: {
      type: String,
      request: true,
    },
  },
  created() {
        this.plain
          .get(`/galleriesName?title=Parador el Potosino`)
          .then((response) => {
            this.galleryParador = response.data
            // console.log(response);
          })
          .catch((err) => {
            this.galleryParador = undefined;
            console.log(err);
          })
      .finally(() => {
        this.plain
          .get(`/galleriesName?title=Parador el Potosino (Slider)`)
          .then((response) => {
            this.galleryPaSlider = response.data
            // console.log(response);
          })
          .catch((err) => {
            this.galleryPaSlider = undefined;
            console.log(err);
          })
      })
  },
};
</script>

<style lang="scss"  scoped>
.card-header {
  position: static;
}

.main-content {
  position: static;
}

.container-fluid {
  position: static;
}

.card-carousel {
  position: static;
}

.col-sm-6 {
  position: static;
}

.col-12 {
  position: static;
}

.card {
  position: static;
}

.carousel {
  position: static;
}</style>